import {
   PrescriptionHistoryDailyGroup,
   PrescriptionHistoryPrescription,
} from '@dreryk/egabinet-prescription-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { Slot } from '@dreryk/watermelon';

import { PrescriptionHistoryFilters } from './PatientPrescriptionHistoryTable.types';

export const isSelectablePrescription = (prescription: PrescriptionHistoryPrescription): boolean =>
   Boolean(prescription.medicine) && (!prescription.confidential || prescription.hasAccess === true);

export const getSelectablePrescriptionIds = (dailyGroup: PrescriptionHistoryDailyGroup): number[] =>
   dailyGroup.prescriptions.filter(isSelectablePrescription).map((prescription) => prescription.prescriptionId);

export const reconcileSelectedPrescriptionIds = (
   selectedIds: Set<number>,
   dailyGroups: PrescriptionHistoryDailyGroup[]
): Set<number> => {
   const inaccessibleIds = new Set(
      dailyGroups.flatMap((group) =>
         group.prescriptions.filter((item) => !isSelectablePrescription(item)).map((item) => item.prescriptionId)
      )
   );
   const next = new Set([...selectedIds].filter((id) => !inaccessibleIds.has(id)));
   return next.size === selectedIds.size ? selectedIds : next;
};

export const resolvePractitionerIds = (
   filters: PrescriptionHistoryFilters,
   currentPractitionerId: number
): Slot<PractitionerId[]> => {
   if (filters.practitionerIds?.length) {
      return Slot.of(filters.practitionerIds.map((id) => PractitionerId.of(id)));
   }

   if (filters.issuedByCurrentPractitioner) {
      return Slot.of([PractitionerId.of(currentPractitionerId)]);
   }

   return Slot.empty();
};
